import moment from "moment";
import RightOutlined from "@ant-design/icons/RightOutlined";
import UserOutlined from  "@ant-design/icons/UserOutlined";
import FieldTimeOutlined from "@ant-design/icons/FieldTimeOutlined";
import CommentOutlined from "@ant-design/icons/CommentOutlined";
import { Modal, Button, Space ,Input} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React from "react";

const { confirm } = Modal;
const {TextArea}=Input;

export default (props) => {
    let {_this, ItemRow} = props;
    const onChangeComment=(e)=>{
        console.log("onChangeComment > ",e.target.value);
        _this.setState({userComment:e.target.value})
    }
    const actionComplete=()=>{
        confirm({
            title: 'Do you Want to Complete this reminder?',
            icon: <ExclamationCircleOutlined />,
            content: <div>
                <p>Customer: {ItemRow.name}</p>
                <p>Subject: {ItemRow.title}</p>
                <p>Comment: {ItemRow.comment}</p>
                <p>Agent: {getAgentName(ItemRow.agent)}</p>
                <p>Created: {formatDateTime(ItemRow.date, ItemRow.time)}</p>
                <p>Type your comment</p>
                <p>
                    <TextArea
                        style={{width:"100%"}}
                        onChange={(e)=>onChangeComment(e)}
                    />
                </p>
            </div>,
            async onOk() {
                console.log('OK');
                await _this.submitCompleteReminder(ItemRow)
            },
            onCancel() {
                console.log('Cancel');
                _this.setState({
                    userComment:"",
                    showSubmitComment:false,
                    selectedRecord:null,
                })
            },
        });
    }
    const getAgentName = (agentEmail) => {
        console.log("Users > ",_this.state.Users)
        let name = agentEmail;
        for(let i in _this.state.Users){
            let row = _this.state.Users[i];
            if(row.Username===agentEmail){
                name = row.FullName;
            }
        }
        return name
    }
    const formatDateTime = (dateIn, timeIn) => {
        let d = dateIn + " " + timeIn;
        if (d === "") {
            return "unknown date"
        }
        return moment(d, "YYYY-MM-DD HH:mm:ss").format(" ddd DD-MMM-YYYY HH:mm")
    }
    const findDuration = (dateIn, timeIn) => {
        let d = dateIn + " " + timeIn;
        let end = moment(d,"YYYY-MM-DD HH:mm:ss");
        let now = moment();
        let duration = end.diff(now,"hours");
        if (d === "") {
            return "0 hours"
        }
        return duration
    }

    let dur = findDuration(ItemRow.scheduledate, ItemRow.scheduledtime);
    let durColor = "green";
    let status = "Active";
    if(dur <=0){
        durColor="red";
        status = "Expired";
    }
    return (
        <div style={styles.container}>
            <div style={styles.boxIcon} onClick={actionComplete}>
                <RightOutlined style={styles.icon}/>
            </div>
            <div style={styles.boxDetail}>
                <p style={styles.Subject}  onClick={actionComplete}>
                    {ItemRow.title}
                </p>
                <p style={styles.DateTime}>
                    <span style={{color:durColor}}>Due</span>:{formatDateTime(ItemRow.scheduledate, ItemRow.scheduletime)} &nbsp;|&nbsp;
                    Status: {status}
                </p>
                <p style={styles.DateTime}>
                    <CommentOutlined style={{color:"black",marginRight:5}}/>:{ItemRow.comment}
                </p>
                <p style={styles.Agent}>
                    <UserOutlined style={{color:"red",marginRight:5}}/>: {ItemRow.name} &nbsp;|&nbsp;
                    <span style={{color:"orange",marginRight:5}}>Agent</span>: {getAgentName(ItemRow.agent)} &nbsp;|&nbsp;
                    <FieldTimeOutlined style={{color:"blue",marginRight:5}}/>: { formatDateTime(ItemRow.date, ItemRow.time)}
                </p>
            </div>
            <div style={styles.boxDuration}   onClick={actionComplete}>
                <span style={{...styles.duration,color:durColor}}>{dur} hours</span>
            </div>
        </div>
    )
}

const styles={
    Agent:{
        color:"gray",
        fontSize:14,
    },
    DateTime:{
        color:"gray",
        fontSize:16,
    },
    Subject:{
        color:"lightblue",
        fontSize:22,
        fontWeight:"bold",
        cursor:"pointer"
    },
    duration:{
      color:"green",
      fontSize:22,
      fontWeight:"bold",
        cursor:"pointer"
    },
    boxDetail:{
        minWidth:"75%",
        maxWidth:"75%",
        alignItems:"center",
        justifyContent:"flex-start",
        /*backgroundColor:"red",*/

    },
    boxDuration:{
        minWidth:"15%",
        maxWidth:"15%",
        justifyContent:"flex-end",
        alignItems:"center",
        display: "flex",

    },
    boxIcon:{
        minWidth:"5%",
        maxWidth:"5%",
        justifyContent:"center",
        alignItems:"center",
        cursor:"pointer"
    },
    container:{
        minWidth:"100%",
        maxWidth:"100%",
        flexDirection:"row",
        display:"flex",
        margin:10,
        borderBottomWidth:1,
        borderBottomColor:"lightgray",
        borderBottomStyle:"solid",
        borderRadius:5,
    }
}
